import React from 'react'
import { Form, Row, Col, Dropdown } from 'react-bootstrap'

const DropdownDate = ({ rounds, setRoundDate }) => {
  return (
    <Form>
      <Row>
        <b style={{ marginTop: '17px', marginLeft: '20px' }}>งวดวันที่: </b>
        <Col sm={12} md={6} lg={4}>
          <Dropdown>
            <select
              className="form-control"
              style={{ color: '#5d5d5d' }}
              onChange={async (value) => {
                setRoundDate(value.target.value)
                //   fetchLotteries(1, undefined, {
                //     currentRoundDate: value.target.value,
                //   });
              }}
            >
              {rounds &&
                rounds.map((round, i) => {
                  return (
                    <option key={i} value={round.roundDate}>
                      {round.roundDate}
                    </option>
                  )
                })}
            </select>
          </Dropdown>
        </Col>
      </Row>
    </Form>
  )
}

export default DropdownDate
